import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (data) => api.post('/auth/register', data),
  getMe: () => api.get('/auth/me'),
};

export const projectsAPI = {
  getAll: () => api.get('/projects'),
  getOne: (id) => api.get(`/projects/${id}`),
  create: (data) => api.post('/projects', data),
  update: (id, data) => api.put(`/projects/${id}`, data),
  delete: (id) => api.delete(`/projects/${id}`),
};

export const documentsAPI = {
  getAll: () => api.get('/documents'),
  upload: (file, storageType = 'both') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('storage_type', storageType);
    return api.post('/documents/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  download: (id, source = 'gridfs') => api.get(`/documents/${id}/download?source=${source}`, { responseType: 'blob' }),
  delete: (id) => api.delete(`/documents/${id}`),
};

export const imagesAPI = {
  getAll: () => api.get('/images'),
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/images/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  delete: (id) => api.delete(`/images/${id}`),
};

export const investorsAPI = {
  getAll: () => api.get('/investors'),
  create: (data) => api.post('/investors', data),
  updateStatus: (id, status) => {
    const formData = new FormData();
    formData.append('status', status);
    return api.put(`/investors/${id}/status`, formData);
  },
};

export const aiAPI = {
  chat: (message) => api.post('/chat', { message }),
};

export const apiKeysAPI = {
  get: () => api.get('/api-keys'),
  update: (data) => api.put('/api-keys', data),
};

export const financialAPI = {
  get: () => api.get('/financial'),
  update: (data) => api.put('/financial', data),
};

export const teamAPI = {
  getAll: () => api.get('/team'),
  add: (data) => api.post('/team', data),
  delete: (id) => api.delete(`/team/${id}`),
  update: (data) => api.put('/team', data),
};

export const partnersAPI = {
  getAll: () => api.get('/partners'),
  add: (data) => api.post('/partners', data),
  delete: (id) => api.delete(`/partners/${id}`),
  update: (data) => api.put('/partners', data),
};

export default api;
